"use strict";

// Requires marionette because it adds Wreqr prop to Backbone :(
define(['marionette', 'backbone'], function (Marionette, Backbone) {
  return Backbone.Wreqr.radio.channel('events');
});